import enLocale from './en'
export default {
  Growth: {
    rentalTitle: "Mietmarkt",
    rentalDesc: "Miete Lizenzen von anderen Haltern; vermiete deine und erziele Erträge",
    listingCount: "Im Angebot",
    avgDailyRent: "Ø Miete/Tag",
    deals7d: "Abschlüsse (7T)",
    totalRent: "Gesamtmiete",
    termLabel: "Laufzeit",
    dailyRent: "Pro Tag",
    annualized: "Annualisiert",
    rentNow: "Mieten",
    sortDaily: "Nach Miete/Tag",
    sortTerm: "Nach Laufzeit",
    sortPrice: "Nach Preis",
    sortNewest: "Neueste",

    leaderboard: "Rangliste",
    leaderboardDesc: "Trader-Rangliste nach on-chain abgerechneten Ergebnissen",
    winRate: "Trefferquote",
    bets: "Wetten",
    volume: "Volumen",
    record: "{w}S · {l}N",
    winLose: "S / N",
    loadMore: "Mehr laden",
    empty: "Keine Daten",
    trader: "Trader",
    rankLabel: "Rang",
    selling: "Zum Verkauf",
    recent: "Letzte Ergebnisse",
    none: "Keine",
    follow: "Kopieren",
    modeSale: "Verkauf",
    modeRental: "Vermietung",
    day: "T",
    periodAll: "Alle",
    period90: "90T",
    period30: "30T",
    period7: "7T",
    sortRoi: "Nach ROI",
    sortProfit: "Nach G&V",
    sortWinRate: "Nach Quote",
    sortVolume: "Nach Volumen",
    sortBets: "Nach Wetten",
    referralCenter: "Empfehlungszentrum",
    referralRewards: "Empfehlungsprämien",
    referralRewardsDesc: "Lade Freunde ein, teilt die Prämien und verfolgt die VIP-Pools",
    myMode: "Mein Modus",
    modeTeam: "Team",
    modeAgent: "Agent",
    l1Rate: "L1-Satz",
    l2Rate: "L2-Satz",
    myUpline: "Mein Upline",
    uplineNone: "Keiner",
    myVip: "VIP-Stufe",
    vipNotEnabled: "VIP-Pools sind nicht aktiviert",
    vipNext: "Nächste Stufe",
    vipDirect: "Direkt",
    vipAsset: "Persönliches Vermögen",
    vipTeamQualified: "Qualifiziertes Team",
    vipPools: "Berechtigte Pools",
    tabTeam: "Team",
    teamLevel: "Ebene",
    teamMembers: "Mitglieder",
    tabCommission: "Provisionen",
    commLevel: "Ebene",
    commRate: "Satz",
    commAmount: "Betrag",
    statusPending: "Ausstehend",
    statusSettled: "Abgerechnet",
    channelOnChain: "On-Chain",
    channelPlatform: "Plattform",
    communityGroup: "Community & mehr",
    referralDesc: "Lade Freunde ein, baue die Community auf und erhalte Provisionen.",
    connectFirst: "Verbinde deine Wallet, um dein Empfehlungszentrum zu öffnen",
    directInvites: "Direkte Einladungen",
    totalDownline: "Gesamt im Team",
    earned: "Provisionen gesamt",
    pendingClaim: "Ausstehend",
    myReferrer: "Empfohlen von",
    inviteLink: "Dein Einladungslink",
    copy: "Kopieren",
    copied: "Kopiert!",
    linkHint: "Freunde, die diesen Link öffnen und sich on-chain binden, zählen als deine Einladungen.",
    tabInvitees: "Meine Einladungen",
    tabRewards: "Provisionsverlauf",
    tabTop: "Top-Werber",
    invitesCol: "Einladungen",
    typeInvite: "Einladung",
    typeReward: "Provision",
    typeWithdraw: "Auszahlung",
    bindTitle: "Empfehler verknüpfen",
    bindDesc: "Die Verknüpfung wird serverseitig an Ihre Wallet-Adresse gebunden und bleibt auf jedem Gerät erhalten.",
    bindPlaceholder: "Adresse des Empfehlers eingeben (0x...)",
    bindButton: "Signieren & verknüpfen",
    bindFromLink: "Aus Einladungslink",
    bindLocked: "Der Empfehler kann nur einmal festgelegt werden.",
    bindSuccess: "Empfehler verknüpft",
    bindFailed: "Verknüpfung fehlgeschlagen",
    bindSelf: "Sie können sich nicht selbst verknüpfen",
    bindCancelled: "Signatur abgebrochen",
  },
  progress: "Fortschritt",
  timeLeft: "Noch {t}",
  ended: "Beendet",
  fundTitle: "Guthaben",
  fundDesc: "Vertrags- und Wallet-Guthaben für jeden unterstützten Token",
  token: "Token",
  contractBalance: "Vertragsguthaben",
  lockedAmount: "Gesperrt",
  unlockTime: "Freigabe in",
  depositToContract: "Zum Vertrag einzahlen",
  withdrawToWallet: "Zur Wallet auszahlen",
  available: "Verfügbar",
  max: "Max",
  withdraw: "Auszahlen",
  deposit: "Einzahlen",
  approve: "Freigeben",
  withdrawTip: "Auszahlungen bleiben kurz gesperrt, bevor sie in deiner Wallet ankommen.",
  connectWallet: "Wallet verbinden",
  ...enLocale,
  language: 'Sprache',
  confirm: 'Bestätigen',
  go: 'Gehen',
  status: 'Status',
  balance: 'Kontostand',
  cash: 'Bargeld',
  createNew: 'Neu erstellen',
  home: 'Startseite',
  market: 'Markt',
  markets: 'Märkte',
  community: "Community",
  deposit: "Einzahlen",
  bridge: "Bridge",
  portfolio: 'Portfolio',
  license: 'Lizenz',
  withdraw: 'Abheben',
  auditChecking: 'Prüfung läuft',
  insufficientFunds: 'Unzureichende Mittel',
  buy: 'Kaufen',
  history: 'Verlauf',
  seeMore: 'Mehr ansehen',
  theme: 'Thema',
  network: 'Netzwerk',
  walletBalance: 'Wallet-Guthaben',
  collect: 'Einsammeln',
  approve: 'Freigeben',
  ticket: 'Lizenz',
  category: 'Kategorie',
  sortBy: 'Sortieren nach',
  issue: 'Veröffentlichen',
  detail: 'Details',
  stakingType: 'Sicherheit',
  stakingTypeInfo: 'Stake Tokens oder aktuelles NFT, um falsche Bestätigungen zu verhindern.',
  subscriptionAmount: 'Kaufsumme',
  subscription: 'Subskription',
  subscribe: 'Kaufen',
  max: 'Max',
  marketClosed: 'Markt geschlossen',
  deposit: 'Hinzufügen',
  verifiedNFT: 'Lizenz prüfen',
  select: 'Auswählen',
  selected: 'Ausgewählt',
  moreNFT: 'Mehr Lizenzen holen',
  forecastEvent: 'Ereignis',
  subscribeEndDate: 'Letzte Handelszeit',
  specifyExpiryDate: 'Ablaufzeit festlegen',
  endDate: 'Endzeit',
  validityPeriod: 'Ablaufzeit',
  marketEndDate: 'Ablaufzeit',
  liquidityMin: 'Mindestliquidität',
  premiumMin: 'Min. Prämie',
  paymentCurrency: 'Zahlungswährung',
  defaultOdds: 'Standardhebel',
  setDefaultOdds: 'Hebel setzen',
  minInvestAmout: 'Mindestinvestition festlegen',
  depositMargin: 'Liquidität hinzufügen',
  totalPayment: 'Gesamtzahlung',
  rewards: 'Belohnungen',
  rewardRate: 'Belohnungsrate',
  release: 'Freigeben',
  fee: 'Gebühr',
  marginFeeRate: 'Gebührensatz',
  cdsInfoOne: 'Für die Veröffentlichung Marge staken, Hebel & Minimum festlegen.',
  cdsInfoTwo: 'Nicht genutzte Marge jederzeit abhebbar.',
  cdsInfoThree: 'Mehr als eine Beschwerde startet Governance.',
  deposited: 'Investiert',
  issued: 'Veröffentlicht',
  depositedCDS: 'investierte Produkte',
  totalProfit: 'Gesamtgewinn',
  allOrDeposited: 'Gesamt/Investiert',
  rewardsOrProfit: 'Belohnung/Gewinn',
  estimatedInvested: 'Schätzung/Investiert',
  profit: 'Gewinn',
  yesterdayProfit: 'Gewinn gestern',
  eventConfirming: 'Ereignis wird bestätigt',
  appeal: 'Anfechtung',
  appealing: 'Anfechtung läuft',
  appealFailed: 'Anfechtung fehlgeschlagen',
  occured: 'Eingetreten',
  notOccured: 'Nicht eingetreten',
  governanceMechanism: 'Governance bei >1 Anfechtung',
  appealLimit: 'Max. 1 Anfechtung',
  waitResult: 'Warten auf Anfechtungs-Ergebnis',
  frozenMargin: 'Eingefrorene Marge',
  marginBalance: 'Marge-Guthaben',
  endTime: 'Countdown bis Ende',
  guaranteeing: 'Laufend',
  guaranteeingEvent: 'Prognose läuft',
  confirmsEventAdvance: 'Vorzeitig bestätigt',
  waitConfirmation: 'Bestätigung ausstehend',
  triggerEvent: 'Ereignis eingetreten (bestätigt)',
  notTriggerEvent: 'Ereignis nicht eingetreten',
  defaultChallenging: 'Eingetreten — Anfechtung',
  notDefaultChallenging: 'Nicht eingetreten — Anfechtung',
  defaultChallengeFailed: 'Eingetreten — Anfechtung fehlgeschlagen',
  notDefaultChallengeFailed: 'Nicht eingetreten — Anfechtung fehlgeschlagen',
  defaultWaitingResult: 'Eingetreten — Governance ausstehend',
  notDefaultWaitingResult: 'Nicht eingetreten — Governance ausstehend',
  defaultGovernanceMechanism: 'Eingetreten — Governance bestätigt',
  notDefaultGovernanceMechanism: 'Nicht eingetreten — Governance bestätigt',
  cancel: 'Abbrechen',
  defaultAhead: 'Vorzeitig',
  occur: 'Eintreten',
  notOccur: 'Nicht eintreten',
  stakingToChallenge: 'Stake für Anfechtung',
  challenged: 'Angefochten',
  checking: 'Prüfung',
  fail: 'Fehlgeschlagen',
  appealInfoOne: 'Bei falschem Urteil „Anfechten“, Governance entscheidet.',
  check: 'Prüfen',
  contentIllegal: 'Illegale Inhalte, bitte überarbeiten.',
  subscribed: 'Investierte Produkte',
  receivingCompensation: 'Ausstehend',
  received: 'Gesamt-Auszahlung',
  receive: 'Erhalten',
  compensationAmount: 'Entschädigungsbetrag',
  liquidity: 'Liquidität',
  injectLiquidity: 'Liquidität injizieren',
  uRLContent: 'URL/Inhalt',
  resolutionSource: 'Entscheidungsquelle',
  textareaInfo: 'Ereignis kurz beschreiben.',
  share: 'Teilen',
  USDT: 'USDT',
  donations: 'Spenden',
  issueMsgPleaseSelectLicense: 'Bitte Lizenz auswählen',
  issueMsgLicenseCannotBeStaked: 'Lizenz nicht stakebar',
  issueMsgNetworkNotConnected: 'Netzwerk nicht verbunden',
  issueMsgEventEmpty: 'Ereignis leer',
  issueMsgSelectLicense: 'Lizenz auswählen',
  issueMsgLastTradingDateEmpty: 'Letzte Handelszeit ist leer',
  issueMsgExpirationDateEmpty: 'Ablaufzeit ist leer',
  issueMsgLastTradingDateGreaterThanToday: 'Letzte Handelszeit muss später als heute sein',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Letzte Handelszeit liegt nach der Ablaufzeit',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Ereignis-Endzeit {eventEndDate} ist größer als Miet-Endzeit {rentalEndDate}',
  issueMsgOptionsEmpty: 'Optionen dürfen nicht leer sein',
  issueMsgOptionsLessThanTwo: 'Mindestens zwei Optionen',
  issueMsgOptionEmpty: 'Optionsinhalt darf nicht leer sein',
  issueMsgOptionRepeated: 'Optionsinhalt doppelt',
  issueMsgLastTradingDateGreaterThanToday: 'Letzter Tag muss nach heute sein',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Letzter Tag > Ablaufdatum',
  issueMsgLicenseError: 'Lizenzfehler',
  issueMsgTicketError: 'Ticketfehler',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Enddatum {eventEndDate} > Mietende {rentalEndDate}',
  issueMsgInsufficientBalance: 'Unzureichendes Guthaben',
  issueMsgTransactionFailed: 'Transaktion fehlgeschlagen',
  issueMsgIssueSuccess: 'Veröffentlichung erfolgreich',
  issueMsgTransactionCancelled: 'Transaktion abgebrochen',
  short: {
    confirmsEventAdvance: 'Vorzeitig',
    waitConfirmation: 'Bestätigung ausstehend',
    defaultChallenging: 'Eingetreten — Anfechtung',
    notDefaultChallenging: 'Nicht eingetreten — Anfechtung',
    defaultChallengeFailed: 'Eingetreten — Anfechtung fehlgeschlagen',
    notDefaultChallengeFailed: 'Nicht eingetreten — Anfechtung fehlgeschlagen',
    defaultWaitingResult: 'Eingetreten — Governance',
    notDefaultWaitingResult: 'Nicht eingetreten — Governance',
    defaultGovernanceMechanism: 'Eingetreten — Governance bestätigt',
    notDefaultGovernanceMechanism: 'Nicht eingetreten — Governance bestätigt'
  },
  wallet: {
    openWallet: 'Wallet öffnen',
    connectWallet: 'Wallet verbinden',
    connectingWallet: 'Wallet wird verbunden',
    connectYourWallet: 'Wallet verbinden',
    disconnect: 'Trennen',
    wrongNetwork: 'Falsches Netzwerk'
  },
  NFT: {
    getPrediLicense: 'Predi-Lizenz erhalten',
    referralRewards: 'Empfehlungsprämien',
    mintYourLicence: 'Lizenz minten',
    usageRights: 'Nutzungsrechte',
    issuePredictionProducts: 'Predictions veröffentlichen',
    governance: 'Governance',
    properties: 'Eigenschaften',
    tradable: 'Handelbar',
    rentable: 'Vermietbar',
    usable: 'Nutzbar',
    marketsToIssue: 'Zu veröffentlichende Märkte',
    times: 'Mal',
    availableTimes: 'Verfügbare Male',
    ticketId: 'Ticket-ID',
    cancelRentHint: 'Lizenz ist vermietet, zum Verkauf zuerst kündigen.',
    sell: 'Verkaufen',
    rent: 'Mieten',
    share: 'Teilen',
    USDT: 'USDT',
    common: 'Gewöhnlich',
    scarcity: 'Seltenheit',
    attributive: 'Attributiv',
    numbers: 'Ausgabeanzahl',
    issueTip: '10 Vorhersage-Märkte/Lizenzen ausgeben',
    price: 'Preis',
    success: 'Erfolg',
    getNFT: 'Lizenz erhalten',
    issueCDS: 'Predi-Märkte veröffentlichen',
    buyNow: 'Jetzt kaufen',
    mintNow: 'Jetzt minten',
    rule: 'Regel',
    comingSoon: 'Demnächst!',
    type: 'Typ',
    from: 'Von',
    to: 'Zu',
    me: 'Ich',
    rented: 'Vermietet',
    sold: 'Verkauft',
    tabGetLicense: 'Lizenz erhalten',
    tabMyLicense: 'Meine Lizenz',
    tabMarket: 'Markt',
    marketDisabled: "Der Sekundärmarkt ist noch nicht verfügbar.",
    bought: 'Gekauft',
    boughtProducts: 'Gekaufte Produkte',
    investedProducts: 'Investierte Produkte',
    issuedProducts: 'Veröffentlichte Produkte',
    positions: 'Positionen',
    options: 'Optionen',
    all: 'Alle',
    volume: 'Volumen',
    newest: 'Neueste',
    price: 'Preis',
    pending: 'Ausstehend',
    audit: 'Audit',
    loading: 'Lädt',
    home: 'Startseite',
    market: 'Markt',
    markets: 'Märkte',
    portfolio: 'Portfolio',
    license: 'Lizenz',
    empowering: 'Visionäre stärken, die Zukunft vorhersagen',
    myPositions: 'Meine Positionen',
    challengeCredit: 'Anfechtungs-Kredit',
    challengeStatus: 'Anfechtungs-Status',
    succeed: 'Erfolgreich',
    wait: 'Warten',
    return: 'Rendite',
    createYourOwnMarket: 'Eigenen Markt erstellen',
    waitChallenge: 'Ereignis wartet auf Anfechtung.',
    waitingGovernanceResult: 'Wartet auf Governance-Ergebnis.',
    eventFinished: 'Ereignis beendet.',
    cancelled: 'Storniert',
    predictionProduct: 'Vorhersageprodukt',
    complaintCountdown: 'Beschwerde-Countdown',
    setResult: 'Ergebnis festlegen',
    challenge: 'Anfechtung',
    recycleTicket: 'Ticket zurückholen',
    eventCancelled: 'Ereignis wurde storniert.',
    auditChecking: 'Prüfung läuft',
    insufficientFunds: 'Unzureichende Mittel',
    buyTicket: 'Ticket kaufen',
    buy: 'Kaufen',
    listYourToken: 'Token listen',
    setResultModalTitle: 'Ergebnis festlegen:',
    cancelModalTitle: 'Abbrechen',
    cancelIrreversible: 'Stornierung ist irreversibel.',
    challengeModalTitle: 'Anfechtung',
    challengeStakeIntro: 'Bei Faktenabweichung Rückerstattung.',
    challengeStakeButton: 'PRDS zur Anfechtung',
    history: 'Verlauf',
    seeMore: 'Mehr ansehen',
    licenses: 'Lizenzen',
    prediLicense: 'Predi-Lizenz',
    issuableQuantity: 'Ausgabemenge',
    disabled: 'Deaktiviert',
    battleImage: 'Battle-Bild',
    upload: 'Hochladen',
    showSample: 'Beispiel anzeigen',
    battleInformation: 'Battle-Informationen',
    baseToken: 'Basistoken',
    collateral: 'Sicherheit',
    currentLicense: 'Aktuelle Lizenz',
    predictionProject: 'Prognoseprojekt:',
    issueExpireIntro: 'Zur Ablaufzeit teilen diejenigen, die die richtige Option gewählt haben, Token aus dem Produktpool basierend auf ihren Beteiligungsanteilen.',
    issueParticipateUntil: 'Teilnahme bis',
    issueConfirmAdvance: 'Der Emittent kann das Ergebnis vor der Ablaufzeit bestätigen, wenn das Ereignis vorher eintritt.',
    issueChallengeWithin7Days: 'Anfechtung binnen 7 Tagen.',
    issueAttention: 'Predi = Unterhaltung/Sozial, Glücksspiel verboten.',
    eventSampleTitle: 'Ereignis',
    issueSampleCrypto: '[Krypto] BTC-Preisbereich Ende 2025?',
    issueSampleFinance: '[Finanzen] Fed-Zinsentscheidung Q3 2025?',
    issueSampleTechnology: '[Technik] Wer bringt den ersten vollautonomen KI-Roboterassistenten?',
    issueSampleSports: '[Sport] Wer gewinnt die WM 2026?',
    issueSampleSociety: '[Gesellschaft] Welche Plattform hat 2025 die meisten MAU?',
    issueSampleOthers: '[Sonstiges] Wann endet der Russland-Ukraine-Krieg?',
    issuerResult: 'Ergebnis des Emittenten',
    daoResult: 'DAO-Ergebnis',
    predictionToken: 'Vorhersage-Token',
    issuer: 'Emittent',
    issuerProfit: 'Gewinn des Emittenten'
  },
  claim: {
    title: 'PRDs kostenlos beanspruchen',
    subtitle: 'PRDs mit einem Klick erhalten',
    walletAddress: 'Wallet-Adresse',
    status: 'Status',
    connectWalletFirst: 'Bitte zuerst Wallet verbinden',
    eligibility: {
      claimed: 'Bereits beansprucht',
      eligible: 'Anspruch berechtigt',
      error: 'Prüffehler'
    },
    button: {
      claim: 'Beanspruchen',
      alreadyClaimed: 'Bereits beansprucht',
      connect: 'Verbinden'
    },
    footerNotice: 'Pro Wallet einmal. Stelle das richtige Netzwerk sicher.',
    messages: {
      connectFirst: 'Bitte zuerst Wallet verbinden',
      claimSuccess: 'Erfolgreich!',
      claimFailed: 'Fehlgeschlagen, später erneut versuchen',
      txCancelled: 'Transaktion abgebrochen',
      onlyOnce: 'Pro Nutzer einmal',
      insufficientBalance: 'Vertragsguthaben unzureichend, später versuchen'
    }
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Bitte Suchbegriff eingeben',
  predictionProduct: 'Vorhersage-Produkt',
  listYourToken: 'Token auflisten',
  description: 'Beschreibung',
  positions: 'Positionen',
  options: 'Optionen',
  all: 'Alle',
  volume: 'Volumen',
  newest: 'Neueste',
  pending: 'Ausstehend',
  audit: 'Audit',
  loading: 'Lädt',
  challengeCredit: 'Anfechtungs-Kredit',
  challengeStatus: 'Anfechtungs-Status',
  succeed: 'Erfolgreich',
  wait: 'Warten',
  return: 'Rendite',
  waitChallenge: 'Ereignis wartet auf Anfechtung.',
  complaintCountdown: 'Beschwerde-Countdown',
  setResult: 'Ergebnis festlegen',
  issueParticipateUntil: 'Teilnahme bis',
  specifyLastTradingDate: 'Letzte Handelszeit festlegen',
  empowering: 'Visionäre stärken, die Zukunft vorhersagen',
  amount: 'Betrag',
  createYourOwnMarket: 'Eigenen Markt erstellen'
}